import { Component, HostBinding, Input } from '@angular/core';
import { IPList } from '@imunify360-api/lists';

@Component({
    selector: 'i360-colored-ip',
    template: `
        <span class="text-nowrap">
            <ng-content></ng-content>
        </span>
    `,
    styleUrls: ['./colored-ip.component.scss'],
})
export class ColoredIpComponent {
    @HostBinding('attr.color') @Input() listName: IPList;
}
